import Link from "components/base/Link";
import Text from "components/base/Text";

function renderInlineNode(node, index) {
  if (node.type === "linebreak") return <br key={index} />;

  if (node.type === "link") {
    return (
      <Link key={index} href={node.url || ""} target={node.target}>
        {(node.children || []).map((child, i) => renderInlineNode(child, i))}
      </Link>
    );
  }

  if (node.type === "text") {
    const text = node.text || "";
    if (!text) return null;
    const fmt = node.format || 0;
    if (fmt === 0) return <span key={index}>{text}</span>;

    let el = text;
    if (fmt & 1) el = <strong>{el}</strong>;
    if (fmt & 2) el = <em>{el}</em>;
    if (fmt & 4) el = <u>{el}</u>;
    if (fmt & 8) el = <s>{el}</s>;
    if (fmt & 16) el = <code>{el}</code>;
    return <span key={index}>{el}</span>;
  }

  return null;
}

function renderBlockNode(node, index, color) {
  const key = `block-${index}`;
  const inline = (node.children || []).map((child, i) =>
    renderInlineNode(child, i),
  );

  switch (node.type) {
    case "paragraph":
      return (
        <Text type="p_lg" mt={2} key={key} color={color}>
          {inline}
        </Text>
      );
    case "heading": {
      const headingMap = {
        h1: "title_lg",
        h2: "title_md",
        h3: "title_sm",
        h4: "p_lg",
        h5: "p_lg",
        h6: "p_lg",
      };
      return (
        <Text
          type={headingMap[node.tag] || "title_sm"}
          my="md"
          key={key}
          color={color}
        >
          {inline}
        </Text>
      );
    }
    case "list": {
      const ListTag = node.listType === "number" ? "ol" : "ul";
      return (
        <Text as={ListTag} type="p_lg" pl={6} my="sm" key={key} color={color}>
          {(node.children || []).map((item, i) => (
            <li key={i} style={{ paddingTop: "4px", paddingBottom: "4px" }}>
              {(item.children || []).map((child, j) =>
                renderInlineNode(child, j),
              )}
            </li>
          ))}
        </Text>
      );
    }
    default:
      return null;
  }
}

export default function RichHeader({ content, color }) {
  if (!content?.root?.children) return null;
  return content.root.children.map((node, i) =>
    renderBlockNode(node, i, color),
  );
}
